export default __webpack_public_path__ + "static/media/bft-mvmt-group-shot@2x.be321f4b.png";